import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    newEventUrl: String,
    newTaskUrl: String,
  }

  connect() {
    this._onDateClick = this._onDateClick.bind(this)
    this._onOutsideClick = this._onOutsideClick.bind(this)
    document.addEventListener('calendar:date-click', this._onDateClick)
  }

  disconnect() {
    document.removeEventListener('calendar:date-click', this._onDateClick)
    this._removePopover()
  }

  _onDateClick(event) {
    const { date, x, y } = event.detail
    this._removePopover()
    this._showPopover(date, x, y)
  }

  _showPopover(date, x, y) {
    const popover = document.createElement('div')
    popover.id = 'calendar-date-popover'
    popover.className = 'fixed z-[9999] bg-base-100 shadow-lg rounded-box border border-base-300'
    popover.style.top = `${y + 8}px`
    popover.style.left = `${x + 8}px`
    popover.innerHTML = `
      <ul class="menu menu-sm p-2 w-44">
        <li>
          <button data-popover-action="event" data-popover-date="${date}">
            <i class="fa-regular fa-calendar w-4"></i> Novo evento
          </button>
        </li>
        <li>
          <button data-popover-action="task" data-popover-date="${date}">
            <i class="fa-regular fa-circle-check w-4"></i> Nova tarefa
          </button>
        </li>
      </ul>
    `

    popover.querySelectorAll('button').forEach(btn => {
      btn.addEventListener('click', (e) => {
        e.stopPropagation()
        const action = btn.dataset.popoverAction
        const clickedDate = btn.dataset.popoverDate
        this._removePopover()
        if (action === 'event') {
          this._openEventForm(clickedDate)
        } else {
          this._openTaskForm(clickedDate)
        }
      })
    })

    document.body.appendChild(popover)
    document.querySelector('.fc')?.style.setProperty('pointer-events', 'none')

    setTimeout(() => {
      document.addEventListener('click', this._onOutsideClick)
    }, 0)
  }

  _onOutsideClick(event) {
    const popover = document.getElementById('calendar-date-popover')
    if (popover && !popover.contains(event.target)) {
      this._removePopover()
    }
  }

  _removePopover() {
    const existing = document.getElementById('calendar-date-popover')
    if (existing) existing.remove()
    document.querySelector('.fc')?.style.removeProperty('pointer-events')
    document.removeEventListener('click', this._onOutsideClick)
  }

  _openEventForm(date) {
    const url = new URL(this.newEventUrlValue, window.location.origin)
    url.searchParams.set('starts_at', date)
    fetch(url, { headers: { Accept: 'text/vnd.turbo-stream.html' } })
      .then(r => r.text())
      .then(html => window.Turbo.renderStreamMessage(html))
  }

  _openTaskForm(date) {
    const url = new URL(this.newTaskUrlValue, window.location.origin)
    url.searchParams.set('due_at', date)
    url.searchParams.set('from_calendar', '1')
    fetch(url, { headers: { Accept: 'text/vnd.turbo-stream.html' } })
      .then(r => r.text())
      .then(html => window.Turbo.renderStreamMessage(html))
  }
}
